import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:py-16">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">善良的嫂子</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-300">
            专注影视剧内容介绍与解析，聚焦热门剧《善良的嫂子》，为你带来剧情梗概、演员资料与优质影视资源推荐。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">快速导航</h4>
          <ul className="mt-4 space-y-3 text-sm text-background-300">
            <li><Link to="/" className="transition-colors hover:text-accent-300">首页</Link></li>
            <li><Link to="/category" className="transition-colors hover:text-accent-300">影视分类</Link></li>
            <li><Link to="/special" className="transition-colors hover:text-accent-300">相关专题</Link></li>
            <li><Link to="/about" className="transition-colors hover:text-accent-300">关于我们</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">热门分类</h4>
          <ul className="mt-4 space-y-3 text-sm text-background-300">
            <li><Link to="/category?cat=电视剧" className="transition-colors hover:text-accent-300">电视剧</Link></li>
            <li><Link to="/category?cat=电影" className="transition-colors hover:text-accent-300">电影</Link></li>
            <li><Link to="/category?cat=综艺" className="transition-colors hover:text-accent-300">综艺</Link></li>
            <li><Link to="/special/special-current-hot" className="transition-colors hover:text-accent-300">当季热播精选</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">联系我们</h4>
          <ul className="mt-4 space-y-3 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <span className="flex h-5 w-5 items-center justify-center"><i className="ri-mail-line"></i></span>
              contact@kind-sister-in-law.com
            </li>
            <li className="flex items-center gap-2">
              <span className="flex h-5 w-5 items-center justify-center"><i className="ri-feedback-line"></i></span>
              <Link to="/about" className="transition-colors hover:text-accent-300">意见反馈</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-300 sm:flex-row md:px-6">
          <p>© 2025 善良的嫂子 · 影视内容介绍平台　本站仅作影视内容介绍展示，不提供播放与下载服务。</p>
          <p>内容仅供参考，版权归相关权利人所有。</p>
        </div>
      </div>
    </footer>
  );
}